import React from "react";
import { MdCheck, MdRemove } from "react-icons/md";

// aria-disabled instead of disabled keeps keyboard focus on the checkbox while it saves.
const Checkbox = ({ checked, onChange, label, disabled = false }) => {
  const filled = checked !== false;
  const Icon = checked === "mixed" ? MdRemove : MdCheck;

  return (
    <button
      type="button"
      role="checkbox"
      aria-checked={checked}
      aria-label={label}
      aria-disabled={disabled || undefined}
      onClick={disabled ? undefined : onChange}
      className={`flex h-4 w-4 shrink-0 items-center justify-center rounded border-[1.5px] ${
        disabled ? "cursor-wait opacity-60" : ""
      } ${filled ? "border-brand bg-brand" : "border-ui-border-strong bg-ui-surface"}`}
    >
      {filled && <Icon className="h-[13px] w-[13px] text-white" />}
    </button>
  );
};

export default Checkbox;
